module.exports = "/packs/trouble_shechan-dcb4e72eb3f172c28422eba2995c86f9.png";